import { render } from "./CollaboratorFilters.vue?vue&type=template&id=6c5828ce&scoped=true"
import script from "./CollaboratorFilters.vue?vue&type=script&lang=js"
export * from "./CollaboratorFilters.vue?vue&type=script&lang=js"

import "./CollaboratorFilters.vue?vue&type=style&index=0&id=6c5828ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5828ce"]])

export default __exports__